import { render, staticRenderFns } from "./ModalImport.vue?vue&type=template&id=88464a3c&scoped=true"
import script from "./ModalImport.vue?vue&type=script&lang=js"
export * from "./ModalImport.vue?vue&type=script&lang=js"
import style0 from "./ModalImport.vue?vue&type=style&index=0&id=88464a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88464a3c",
  null
  
)

export default component.exports